"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableData = void 0;
var pay_api_1 = require("@l2p/pay-api");
var ui_components_1 = require("@l2p/ui-components");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var CancelTranaction_1 = __importDefault(require("./CancelTranaction"));
var useStatus_1 = require("./useStatus");
var useTableData = function (filteredData, revalidateTransactions) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var getStatus = (0, useStatus_1.useGetStatus)();
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'amount',
                    label: t('amount'),
                },
                {
                    field: 'type',
                    label: t('action'),
                },
                {
                    field: 'paymentMethod',
                    label: t('paymentMethod'),
                },
                {
                    field: 'date',
                    label: t('date'),
                },
                {
                    field: 'status',
                    label: t('status'),
                },
                {
                    field: 'action',
                    label: '',
                },
            ],
            rows: [],
        };
        table.rows = filteredData.map(function (item) {
            var type = item.type, paymentMethod = item.paymentMethod, amount = item.amount, createdAt = item.createdAt, status = item.status, currency = item.currency, id = item.id;
            return {
                status: (react_1.default.createElement(ui_components_1.StatusText, { status: getStatus(status), textAlign: "flex-start" }, t("".concat(status)))),
                type: t(type),
                paymentMethod: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.replace(/_/g, ' '),
                amount: "".concat(amount, " ").concat(currency),
                date: (0, date_fns_1.format)(new Date(createdAt), 'HH:mm, dd-LL-yy'),
                action: type === pay_api_1.TransactionTypeEnum.Withdrawal &&
                    status === pay_api_1.TransactionStatusEnum.Pending ? (react_1.default.createElement(CancelTranaction_1.default, { id: id, revalidateTransactions: revalidateTransactions })) : undefined,
            };
        });
        return table;
    }, [getStatus, filteredData, t, revalidateTransactions]);
};
exports.useTableData = useTableData;
